import './NewReportOrder.scss'
import * as React from 'react'
import { inject, observer } from 'mobx-react'
import NewReportOrderForm from './NewReportOrderForm'
import PopupView from '../../common/popupview/PopupView'
import AboutReportModal from '../../../../components/modals/about-report-modal/AboutReportModal'
import RootStore from '../../../../stores/RootStore'
import { TermsOfDeliveryModal } from '@tfo/common'
import { useHistory, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { ICompany } from '@tfo/common/src/models'

export interface NewReportOrderProps {
	rootStore?: RootStore
}
const NewReportOrder = (props: NewReportOrderProps) => {
	const { companyId, reportPackageId } = useParams<{ companyId: string, reportPackageId: string }>()
	const store = props.rootStore!.clientViewStore!
	const { reportStore } = store
	const history = useHistory()
	const [company, setCompany] = useState<ICompany>()
	const [needReportRecipient, setNeedReportRecipient] = useState<boolean>()
	const [orderRecipientIds, setOrderRecipientIds] = useState<number[]>()
	const [reportPackageAddons, setReportPackageAddons] = useState<any[]>()
	useEffect(() => {
		if ((companyId || reportPackageId) && (history.location.pathname.includes('/new-report-order'))) {
			setSelectedReportPackage(parseInt(companyId), parseInt(reportPackageId))
			setSelectedCustomer()
			getReportPackageAddons(parseInt(reportPackageId))
		}
	}, [companyId, reportPackageId])

	const setSelectedReportPackage = async (companyId: number, reportPackageId: number) => {
		store.loading = true
		const selectedCompany = await store.getSubsidiariesCompany(companyId)
		setCompany(selectedCompany)
		await store.getReportPackageBySubsidiaries(companyId)
		store.selectedReportPackage = store.activeReportPackages.find(x => x.id === reportPackageId)
		store.loading = false
	}
	
	const getReportPackageAddons = async (reportPackageId: number) => {
		const addons = await store.getReportPackageAddons(reportPackageId)
		setReportPackageAddons(addons)
	}
	
	const setSelectedCustomer = async () => {
		const customer = await store.getCustomer()
		setNeedReportRecipient(customer.receiverWhenOrdering)
		const recipientIds = await store.getRecipientsId(customer.id)
		setOrderRecipientIds(recipientIds)
	}

	const onGoBack = () => {
		history.push(`/service-packages/${companyId}`)
	}

	return (
		<React.Fragment>
			<PopupView
				onCloseClick={() => onGoBack()}
				className={'NewReportOrder'}>
				{(store?.selectedReportPackage && company && needReportRecipient !== undefined && orderRecipientIds !== undefined) &&
					< NewReportOrderForm
						clientViewStore={store}
						company={company}
						needReportRecipient={needReportRecipient}
						orderRecipientIds={orderRecipientIds}
						reportPackageAddons={reportPackageAddons}
					/>
				}
			</PopupView>

			{store.modalOpen && (
				<AboutReportModal
					data={store.selectedReportPackage}
					onCloseClick={() => store.toggleModal()}
				/>
			)}
		</React.Fragment>
	)
}

export default inject('rootStore')(observer(NewReportOrder))
